import React from 'react';
import {
  Dialog,
  DialogBody,
  DialogFooter,
  Button,
  HeadingText,
  BodyText,
} from '@spotoninc/nexus-react';

/**
 * A customizable confirmation dialog for various actions
 *
 * @param {Object} props - Component props
 * @param {boolean} props.isOpen - Whether the dialog is open
 * @param {Function} props.onClose - Function to call when the dialog is closed
 * @param {Function} props.onConfirm - Function to call when the action is confirmed
 * @param {string} props.title - The title of the dialog
 * @param {string} props.body - The body text of the dialog
 * @param {string} props.cancelButtonText - Text for the cancel button
 * @param {string} props.confirmButtonText - Text for the confirm button
 * @param {string} props.confirmButtonColor - Background color for the confirm button
 */
const ConfirmationDialog = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Confirm Action',
  body = 'Are you sure you want to proceed with this action?',
  cancelButtonText = 'Cancel',
  confirmButtonText = 'Confirm',
  confirmButtonColor = '#D54041',
}) => {
  return (
    <Dialog isOpen={isOpen} onClose={onClose} title={title}>
      <DialogBody>
        <BodyText size="medium" color="neutral.700">
          {body}
        </BodyText>
      </DialogBody>
      <DialogFooter>
        <Button variant="tonal" onClick={onClose}>
          {cancelButtonText}
        </Button>
        <Button
          style={{
            backgroundColor: confirmButtonColor,
            _hover: { backgroundColor: '#E2E8F0' },
          }}
          onClick={() => {
            onConfirm();
            onClose();
          }}
        >
          {confirmButtonText}
        </Button>
      </DialogFooter>
    </Dialog>
  );
};

export default ConfirmationDialog;
